export default function Success() {
    const finalUrl = process.env.REACT_APP_FINAL_URL || "https://moedasocialcarbono.org.br";

    const handleClick = () => {
            window.location.href = finalUrl
    }

    return (
        <div className="background-container">
            <div className="container">
                <img src={process.env.PUBLIC_URL + '/icon512.png'} alt='Logo' width={300} height={42}></img>
                <h1>Obrigado!</h1>
                <p>Seus documentos foram enviados e estão sendo validados</p>
                <button onClick={() => handleClick()}>
                    Voltar para o site
                </button>
            </div>
        </div>
    );
}